<mat-toolbar color="accent">
  <span>Select Patient Files</span>
</mat-toolbar>

<mat-dialog-content>
  <pr-media-manager
    [media]="media()"
    [patient]="data.patient"
    (mediaSelectionChange)="mediaSelected($event)"
  />
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!hasChanges()"
      (click)="addFiles()"
    >
      Add Files
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
